import { createFileRoute } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { InvestorHomeRedirect } from '../../../../components/investor-home-redirect'
import { DealFlowStartupPage } from '../../../../features/legacy-investor/deal-flow-detail-page'

// A Deal Flow match is gone; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/deal-flow_/$startupId')({
  component: () => (
    <AssistantSwitch assistant={<InvestorHomeRedirect />} classic={<DealFlowStartupPage />} />
  ),
})
